const LOGO_URL = "https://customer-assets.emergentagent.com/job_mid-del-auto/artifacts/axdyn9hl_C1793D7D-455B-4CCD-9B2F-3C7E85DE9D86.png";

const Logo = ({ className = "h-10 w-10", alt = "Mid Del Auto" }) => (
  <img src={LOGO_URL} alt={alt} className={className} loading="lazy" />
);

export default Logo;
export { LOGO_URL };
